import { useEffect } from "react";

import useTenantAwareNavigation from "./useTenantAwareNavigation";

import { HTTP_STATUS_CODE } from "@/constants/global";
import { ROUTE } from "@/constants/route";
import { type APIErrorResponse } from "@/types/global";

export const useNotFoundNavigation = (error: unknown): void => {
  const navigate = useTenantAwareNavigation();

  useEffect(() => {
    if ((error as APIErrorResponse<unknown>)?.status === HTTP_STATUS_CODE.NOT_FOUND) {
      navigate(ROUTE.HOME.to);
    }
  }, [error, navigate]);
};
